import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/shared/components/ui/avatar";

import { UserProfileData } from "@/lib/hooks/use-enhanced-user-profile";

interface NavUserProps {
  user: UserProfileData;
  onSignOut: () => void;
  variant?: "header";
  compactOnMobile?: boolean;
}

export function NavUser({
  user,
  onSignOut,
  variant = "header",
  compactOnMobile = false,
}: NavUserProps) {
  // Create initials for avatar fallback
  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((part) => part[0])
      .join("")
      .toUpperCase()
      .substring(0, 2);
  };

  // Header variant - displays user info and avatar
  return (
    <div className="flex items-center cursor-pointer">
      <Avatar className="h-[40px] w-[40px] rounded-full hover:opacity-90 transition-opacity duration-300">
        <AvatarImage src={user.avatar} alt={user.name} />
        <AvatarFallback className="rounded-full w-[40px] h-[40px] bg-light animate-pulse">
          {getInitials(user.name)}
        </AvatarFallback>
      </Avatar>
    </div>
  );
}
